import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const TemplatePage: FC = () => {  
    return (
        <Outlet />
    );
}

export default TemplatePage